import { Investment } from 'entities-next/fundingRounds'
import TrashIcon from 'mdi-react/TrashIcon'
import React from 'react'
import { FormContainer } from 'scenes/Dashboard/components-next/Forms'
import { makeStyles } from 'tss-react/mui'
import { FormHelpers, FormManager } from 'utils-next/forms'
import { ExtendableStyles, Testable } from 'utils-next/types'

import { Button, IconButton, Theme } from '@mui/material'

import {
  getInvestmentValidation,
  InvestmentFormData,
  parseFormInvestment,
  parseInvestmentToFormData,
} from './InvestmentForm.data'
import { InvestmentFormContent } from './InvestmentFormContent.component'

export type InvestmentFormProps = ExtendableStyles &
  Testable & {
    data: Investment
    onUpdate: (data: Investment) => Promise<any> | any
    onDelete: () => any
  }

export function InvestmentForm({ onUpdate, onDelete, data, ...otherProps }: InvestmentFormProps) {
  const { classes } = useStyles()
  const initialValues = parseInvestmentToFormData(data)

  const handleSubmit = async (data: InvestmentFormData, { setSubmitting }: FormHelpers<InvestmentFormData>) => {
    setSubmitting(true)
    const fundingRoundData = parseFormInvestment(data)
    await onUpdate(fundingRoundData)
    setSubmitting(false)
  }

  return (
    <FormManager<InvestmentFormData>
      initialValues={initialValues}
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={getInvestmentValidation()}
      onSubmit={handleSubmit}
    >
      {(formProps) => (
        <FormContainer disabled={formProps.isSubmitting} onSubmit={formProps.handleSubmit} {...otherProps}>
          <InvestmentFormContent className={classes.content} {...formProps} />

          <div className={classes.actions}>
            <IconButton className={classes.actionButtons} aria-label="delete" onClick={onDelete}>
              <TrashIcon />
            </IconButton>

            <Button
              variant="outlined"
              className={classes.actionButtons}
              onClick={formProps.submitForm}
              type="button"
              aria-label="submit"
            >
              Save
            </Button>
          </div>
        </FormContainer>
      )}
    </FormManager>
  )
}

const useStyles = makeStyles()(({ spacing }: Theme) => ({
  content: {
    width: '100%',
    marginBottom: spacing(3),
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  actionButtons: {
    marginLeft: spacing(2),
  },
}))
